module.exports = __webpack_public_path__ + "static/img/theme4.730a62d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme4.jpg
// module id = 2Zuh
// module chunks = 1